import clsx from 'clsx';
import { ClientType } from '../../../types/resources/ClientType';
import { ActionTableColumnsType } from '../../../types/table/ActionTableColumnsType';
import { ActionTableSortParamsType } from '../../../types/table/ActionTableSortParamsType';
import { TableRoot } from '../../common/Table/TableBase/TableRoot';
import styles from './styles.module.scss';

type Props = {
  columns: ActionTableColumnsType[];
  rows: ClientType[];
  sortParams: ActionTableSortParamsType;
  headerSort: (column: string) => void;
  handleToggleSelectAll: () => void;
  renderCheckbox: (row: ClientType) => React.ReactNode;
  toggleSelectForRow: (row: ClientType) => void;
  selectAllState: true | false | 'indeterminate';
};

// プッシュ通知の作成画面（pages/PushNotification/Create）から使用されている。
// 旧一覧（pages/PushNotification/Index が使う TableContent / TableFilter）を削除するときに
// components/pushNotification/ ごと消さないこと
export const CreateFormClientTableContent: React.FC<Props> = ({
  columns,
  rows,
  sortParams,
  headerSort,
  handleToggleSelectAll,
  renderCheckbox,
  toggleSelectForRow,
  selectAllState,
}: Props) => {
  const getNestedValue = (obj: ClientType, path: string) => {
    return path.split('.').reduce((acc, part) => acc?.[part], obj);
  };

  const tableRows =
    rows !== undefined ? (
      rows.map((row: ClientType) => {
        return (
          <tr key={row.id} className={clsx(styles.tableRow)} data-testid={`table-row-${row.id}`}>
            {columns.map((column, columnIndex) => (
              <td
                key={column.key}
                className={clsx(styles.tableCell, styles.greyout, {
                  [styles.clickable]: column.key === 'checkbox',
                  [styles.centerAlign]: column.key === 'checkbox',
                })}
                onClick={() => {
                  if (column.key === 'checkbox' && renderCheckbox) {
                    toggleSelectForRow(row);
                  }
                }}
                data-testid={`table-cell-${columnIndex === 0 ? 'no' : column.key}`}
              >
                {column.key === 'checkbox' && renderCheckbox
                  ? renderCheckbox(row)
                  : (getNestedValue(row, column.key) ?? '-')}
              </td>
            ))}
          </tr>
        );
      })
    ) : (
      <></>
    );

  return (
    <>
      {rows?.length === 0 || rows === null ? (
        <div className={styles.emptyTable}>データなし</div>
      ) : (
        <TableRoot
          columns={columns}
          rows={tableRows}
          sortParams={sortParams}
          onClickHeader={column => headerSort(column)}
          onClickHeaderCheckbox={handleToggleSelectAll}
          selectAllState={selectAllState}
        />
      )}
    </>
  );
};
